angular.module('CfcCharity.common').service('CharityReviewService', function() {
  this.getLinkToCharityReview = function(applicationId, reviewLevel) {
    //hack to deal with the fact that review level values / eums are not handled consistently
    reviewLevel = reviewLevel
      .toUpperCase()
      .replace('ELIGIBILITY', '_ELIGIBILITY');
    return `/charity-application-review/?applicationId=${applicationId}&reviewLevel=${reviewLevel}`;
  };
});
